/* ============================================================
   Maui Craft Creations — Theme JavaScript
   Handles: sticky nav, hamburger menu, email signup form
   ============================================================ */

(function () {
  'use strict';

  /* ── Sticky nav shadow on scroll ── */
  function initStickyNav() {
    var header = document.getElementById('site-header');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile hamburger menu toggle ── */
  function initHamburger() {
    var hamburger = document.getElementById('nav-hamburger');
    var mobileNav = document.getElementById('mobile-nav');
    if (!hamburger || !mobileNav) return;

    function closeMobileNav() {
      hamburger.classList.remove('is-open');
      mobileNav.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.setAttribute('aria-label', 'Open navigation menu');
      mobileNav.setAttribute('aria-hidden', 'true');
    }

    function openMobileNav() {
      hamburger.classList.add('is-open');
      mobileNav.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.setAttribute('aria-label', 'Close navigation menu');
      mobileNav.setAttribute('aria-hidden', 'false');
    }

    hamburger.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });

    /* Close drawer on mobile-nav link click */
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMobileNav);
    });

    /* Close drawer when viewport grows past mobile breakpoint */
    var mq = window.matchMedia('(min-width: 1024px)');
    function onBreakpointChange(e) {
      if (e.matches) closeMobileNav();
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onBreakpointChange);
    } else {
      mq.addListener(onBreakpointChange); /* Safari < 14 fallback */
    }

    /* Keyboard: close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        closeMobileNav();
        hamburger.focus();
      }
    });
  }

  /* ── Email signup form ── */
  function initEmailSignup() {
    var form      = document.getElementById('signup-form');
    var formWrap  = document.getElementById('signup-form-wrap');
    var promoWrap = document.getElementById('signup-promo');
    var errorEl   = document.getElementById('email-error');
    var input     = document.getElementById('email-input');
    if (!form || !formWrap || !promoWrap || !input) return;

    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    }

    input.addEventListener('input', function () {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();

      if (!isValidEmail(email)) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.hidden = false;
        }
        input.focus();
        return;
      }

      /* Hide form, show promo code */
      formWrap.hidden = true;
      promoWrap.hidden = false;
      promoWrap.focus();
    });
  }

  /* ── Init on DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initStickyNav();
    initHamburger();
    initEmailSignup();
  }

})();
